<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container d-flex flex-column h-full">
          <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
          >
          </TopAppBar>
          <div class="sm_wrap">
            <div class="sign_wrap">
              <div class="t-headline9">{{ $t("836") }}</div>
              <div class="t-body3 mgt-6 t-color-bodyGrayA">{{ $t("837") }}</div>

              <div class="sign_box">
                <dl class="sign_dl active">
                  <dt>{{ $t("838") }}</dt>
                  <dd>
                    {{ $t("839") }}
                    <br />
                    {{ $t("840") }}
                    <br />
                    {{ $t("841") }}
                  </dd>
                </dl>
                <dl class="sign_dl active">
                  <dt>{{ $t("842") }}</dt>
                  <dd>
                    {{ $t("843") }}<br />
                    {{ $t("844", { str: managerPhone }) }}<br />
                    {{ $t("845") }}
                    <br />
                    <div class="support">
                      <p>{{ $t("846", { str: managerEmail }) }}</p>
                      <!--  : <a href="mailto:support@brand.com">support@brand.com</a> : <a href="tel:02-9182-7364">02-9182-7364</a>-->
                      <p>{{ $t("847", { str: managerPhone }) }}</p>
                    </div>
                  </dd>
                </dl>
                <dl class="sign_dl active">
                  <dt>{{ $t("848") }}</dt>
                  <dd>
                    {{ $t("849") }}
                    <br />
                    {{ $t("850") }}
                    <br />
                    {{ $t("851") }}
                    <br />
                    <div class="support">
                      <p>{{ $t("852", { str: managerEmail }) }}</p>
                      <p>{{ $t("853", { str: managerPhone }) }}</p>
                    </div>
                  </dd>
                </dl>
              </div>

              <div class="sign_btn">
                <p>
                  <router-link tabindex="0"
                    to="/login"
                    class="mdc-button mdc-button--raised btn-red w-full btn-big"
                    style="color: var(--DocumentWhite); background-color: #2d6dcc"
                    >{{ $t("854") }}</router-link
                  >
                </p>
                <p>
                  <button
                    type="button"
                    @click="resend" @keypress="resend" tabindex="0"
                    class="mdc-button mdc-button--raised bg-white t-color-secondaryBtnText w-full btn-big"
                  >
                    {{ $t("855") }}
                  </button>
                </p>
              </div>
            </div>
          </div>

          <!-- <div class=" pda-default">
                        <button class="mdc-button mdc-button--raised btn-red mr8" @click="$router.go(-1)">
                            {{$t('1607')}}

                        </button>
                    </div> -->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
/**
 * 개인정보 취급방침 컴포넌트(Privacy Policy Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
import joinApi from '@/api/joinApi.js'
import memberApi from '@/api/memberApi.js'
import {MDCRipple} from '@material/ripple'
import loginApi from "@/api/loginApi";
import popupApi from "@/api/popupApi";
import localStorageUtil from "@/utils/localStorageUtil";
export default {
    components: {
        TopAppBar
    },
    data() {
        return {
          title: this.$t('1601'),
          htmlPrivacypolicy: null,
          isIdpService: localStorageUtil.isIdpServiceValidate()
        }
    },
    mixins: [topAppBarMixin],
    mounted() {
      this.setMaterialUi()
		$(function(){
				$(".sign_dl dt").click(function(){
					$(this).parent("dl").toggleClass("active");
				});
			});

        this.setTopAppBarCloseOnly(localStorage.getItem('brandName'))

        // 약관정보 API 호출(call api Privacy Policy )
        memberApi.emailVarification({"authType" : "EMAIL"}).then((response) => {
            //console.log(response.data.data)

        }).catch((err) => {
        })

        // 약관정보 API 호출(call api Privacy Policy )
        joinApi.terms().then((response) => {
            // console.log(response.data.data)
            const termsUrl = response.data.data.TERMS_OF_SERVICE;
            const privacyUrl = response.data.data.PRIVACY_STATEMENT;

            joinApi.policyContents(privacyUrl,'text').then((response) => {
                this.htmlPrivacypolicy = response.data
            })
        }).catch((err) => {
        })
    },
    methods:{
        resend(){
            memberApi.emailVarification({"authType" : "EMAIL"}).then((response) => {
              this.checkSignInStatus()

            }).catch((err) => {
            })
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
      login() {
        if (this.isIdpService) {
          this.$moveIdpLogout();
        } else {
          this.$router.push("/login");
        }
      },
	  checkSignInStatus() {
    let loginAuth = this.isIdpService ? loginApi.authToken() : loginApi.authCheck();
      loginAuth.then((response) => {
		      let responseData = response.data.data;
		      let changePasswordRequest = responseData.changePasswordRequest;
		      let emailAuth = responseData.emailAuth;
		      let dormancy = responseData.dormancy;
		      let responsibilityAuth = responseData.responsibilityAuth;
		      let termsAgree = responseData.termsAgree;
		      let storeTransfer = responseData.storeTransfer;
          if (this.isIdpService) {
					  loginApi.setAuthInHeader(responseData.token);
				  }

		      if (dormancy === true) {
		          this.$alert({
		            title: this.$t("824"),
		            content:
		              this.$t("825") +
		              " " +
		              this.$t("826") +
		              "<br>" +
		              this.$t("827", {
		                str:
		                  '<a href="mailto:' +
		                  BRAND_MANAGER_EMAIL +
		                  '">' +
		                  BRAND_MANAGER_EMAIL +
		                  "</a>",
		              }) +
		              "<br>" +
		              this.$t("828", {
		                str:
		                  '<a href="tel:' +
		                  BRAND_MANAGER_PHONE +
		                  '">' +
		                  BRAND_MANAGER_PHONE +
		                  "</a>",
		              }),
		            accept: this.$t("829"),
		          })
		            .then(() => {
                  this.login();
		            })
		            .catch(() => {
                  this.login();
		            });
		        } else if (termsAgree === false) {
		          this.$router.push("/termsagree");
		        } else if (emailAuth === false) {
            this.login();
		        } else if (changePasswordRequest === true) {
		          this.$router.push({ name: "MemberChangePassword" });
		        } else if (responsibilityAuth === false) {
		          this.$alert({
		            title: this.$t("830"),
		            content: this.$t("831") + " " + this.$t("832"),
		            accept: this.$t("833"),
		          })
		            .then(() => {
		              this.$router.push("/verificationcode");
		            })
		            .catch(() => {
                  this.login();
		            });
		        } else if (storeTransfer !== null) {
		          this.$router.push({ name: "StoreTransfer" });
		        } else {
            popupApi
                .fetpopupDetail()
                .then((response) => {
                  this.popupData = response.data.data;
                  if (this.popupData.length > 0) {
                    this.redirectPath =
                        this.$route.query.redirectPath || "/home?showPopup=1";
                    this.$router.push(this.redirectPath);
                  } else {
                    this.redirectPath = this.$route.query.redirectPath || "/home";
                    //this.redirectPath = this.$route.query.redirectPath || '/degree'
                    this.$router.push(this.redirectPath);
                  }
                })
                .catch((error) => {
                  console.log("err", error);
                });

		          //this.$router.push(this.redirectPath)
		        }
		      })
		      .catch((err) => {
		      const responseData = err.response.data.meta;

		      if (responseData.errCode === 1201) {
		          //관리자 승인 대기중(Waiting for administrator approval)
		          // 매장 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.
		          //this.$snackOpen({contents: 'Todo 관리자 승인 대기중 입니다. 관리자에게 문의해주세요.', btnDisplayYN: false}).then(() => {})

		          this.$alert({
		          title: this.$t("779"), //가입 승인 대기 상태입니다.
		          content:
		              this.$t("780") +
		              "<br>" +
		              this.$t("781", {
		              str:
		                  '<a href="mailto:' +
		                  BRAND_MANAGER_EMAIL +
		                  '">' +
		                  BRAND_MANAGER_EMAIL +
		                  "</a>",
		              }) +
		              "<br>" +
		              this.$t("782", {
		              str:
		                  '<a href="tel:' +
		                  BRAND_MANAGER_PHONE +
		                  '">' +
		                  BRAND_MANAGER_PHONE +
		                  "</a>",
		              }),
		          accept: this.$t("783"),
		          })
		          .then(() => {})
		          .catch(() => {});
		      } else if (responseData.errCode === 1202) {
		          this.$alert({
		          title: this.$t("779"), //가입 승인 대기 상태입니다.
		          content:
		              this.$t("780") +
		              "<br>" +
		              this.$t("781", {
		              str:
		                  '<a href="mailto:' +
		                  BRAND_MANAGER_EMAIL +
		                  '">' +
		                  BRAND_MANAGER_EMAIL +
		                  "</a>",
		              }) +
		              "<br>" +
		              this.$t("782", {
		              str:
		                  '<a href="tel:' +
		                  BRAND_MANAGER_PHONE +
		                  '">' +
		                  BRAND_MANAGER_PHONE +
		                  "</a>",
		              }),
		          accept: this.$t("783"),
		          })
		          .then(() => {})
		          .catch(() => {});
		      } else if (responseData.errCode === 1204) {
		          this.$alert({
		          title: this.$t("1482"), //가입 승인 대기 상태입니다.
		          content:
		              this.$t("1483") +
		              "<br>" +
		              this.$t("1484") +
		              ": " +
		              '<a href="mailto:' +
		              BRAND_MANAGER_EMAIL +
		              '">' +
		              BRAND_MANAGER_EMAIL +
		              "</a>" +
		              "<br>" +
		              this.$t("1485") +
		              ": " +
		              '<a href="tel:' +
		              BRAND_MANAGER_PHONE +
		              '">' +
		              BRAND_MANAGER_PHONE +
		              "</a>",
		          accept: this.$t("1486"),
		          })
		          .then(() => {})
		          .catch(() => {});
		      } else if (responseData.errCode === 1205) {
		          this.$alert({
		          title: this.$t("1914"), //가입 승인 대기 상태입니다.
		          content:
		              this.$t("1915") +
		              " " +
		              this.$t("1916") +
		              "<br>" +
		              this.$t("1917", {
		              str:
		                  '<a href="mailto:' +
		                  BRAND_MANAGER_EMAIL +
		                  '">' +
		                  BRAND_MANAGER_EMAIL +
		                  "</a>",
		              }) +
		              "<br>" +
		              this.$t("1918", {
		              str:
		                  '<a href="tel:' +
		                  BRAND_MANAGER_PHONE +
		                  '">' +
		                  BRAND_MANAGER_PHONE +
		                  "</a>",
		              }),
		          accept: this.$t("1919"),
		          })
		          .then(() => {})
		          .catch(() => {});
		      } else if (responseData.errCode === 1105) {
		          this.$alert({
		          content: this.$t("1875"),
		          accept: this.$t("1876"),
		          })
		          .then(() => {})
		          .catch(() => {});
		      } else if (responseData.errCode === 1335) {
		          //아이디 계정 일시 정지(Suspend Account)
		          // 로그인 정보가 5회 이상 일치하지 않아 30분간 로그인 정지되었습니다. 30분 후 다시 시도해주세요.
		          this.$snackOpen({
		          contents: this.$t("323"),
		          btnDisplayYN: false,
		          }).then(() => {});
		      } else {

		      }
		});
    	},
    },


}
</script>
<style scoped>
.terms {
  position: relative;
  color: var(--Primary);
  font-size: 13px;
  font-family: inherit;
  margin: 0;
  padding: 0;
}
.terms * {
  margin: 0;
  padding: 0;
}
.terms ul,
.terms li {
  list-style: none;
}
.terms h2 {
  font-size: 16px;
  font-weight: bold;
  padding: 0 0 20px 0;
}
.terms div,
.terms p,
.terms ul {
  line-height: 1.4;
}
.terms .txt {
  font-size: 13px;
  padding: 5px 0;
}
.terms .tit {
  font-size: 14px;
  font-weight: bold;
  padding: 15px 0 5px 0;
}
.terms ul {
  position: relative;
  padding-left: 20px;
}
html[dir="rtl"] .terms ul {
  padding-right: 20px;
}
.terms ul li {
  padding: 0 0 5px 0;
}

.sign_wrap {
  position: relative;
  padding: 15px 15px 75px 15px;
  background: var(--DocumentWhite);
}
.sign_wrap > h2 {
  font-size: 22px;
  font-weight: bold;
  color: var(--HeadlineBlack);
}
.sign_wrap .sign_tail {
  position: relative;
  padding: 5px 0 0 0;
  color: var(--BodyGrayA);
  font-size: 14px;
}
.sign_box {
  position: relative;
  box-shadow: 0 1px 3px 0 var(--Shadow1);
  border-radius: 4px;
  margin-top: 15px;
}
.sign_dl {
  position: relative;
  border-bottom: 1px solid var(--Divider);
  margin: 0px;
}
.sign_dl dt {
  padding: 15px 40px 15px 15px;
  color: var(--HeadlineBlack);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  word-break: break-word;
}
html[dir="rtl"] .sign_dl dt {
  padding: 15px 15px 15px 40px;
}
.sign_dl dt:after {
  content: "";
  width: 24px;
  height: 24px;
  display: inline-block;
  background: url(../../assets/open_bullet.png) center center no-repeat;
  position: absolute;
  right: 15px;
  top: 14px;
  background-size: 18px auto !important;
}
html[dir="rtl"] .sign_dl dt:after {
  left: 15px;
}
.sign_dl dd {
  position: relative;
  padding: 4px 15px 15px 15px;
  color: var(--BodyGrayA);
  font-size: 14px;
  line-height: 1.57;
  overflow: hidden;
  margin: 0px;
  display: none;
}
.sign_dl.active dd {
  height: auto;
  display: block;
}
.sign_dl.active dt:after {
  background: url(../../assets/close_bullet.png) center center no-repeat;
}
.sign_dl .support {
  position: relative;
  padding: 15px 0 0 0;
  color: var(--BodyGrayA);
}
.sign_dl .support p {
  position: relative;
  margin-bottom: 5px;
  color: var(--BodyGrayA);
  margin-top: 2px;
}
.sign_dl .support p:nth-last-child(1) {
  margin-bottom: 0;
}
.sign_dl .support a {
  color: var(--SignBlue);
  text-decoration: underline;
}
.sign_btn {
  position: relative;
  padding: 40px 0 0 0;
}
.sign_btn > p {
  position: relative;
  margin-bottom: 10px;
}
.sign_btn > p:nth-last-child(1) {
  margin-bottom: 0;
}
.sign_btn a {
  display: block;
  background: var(--DisableBtn);
  color: var(--DocumentWhite);
  font-size: 14px;
  text-align: center;
  padding: 12px 10px;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 var(--Shadow3);
}
.sign_btn a.on {
  background: var(--Mainbtn);
}
.sign_pop {
  position: fixed;
  left: 10px;
  bottom: 15px;
  width: calc(100% - 20px);
  padding: 15px;
  color: var(--DocumentWhite);
  font-size: 14px;
  border-radius: 4px;
  box-shadow: 0 3px 5px 0 var(--Shadow1);
  background: var(--HeadlineBlack);
  box-sizing: border-box;
}
html[dir="rtl"] .sign_pop {
  right: 10px;
  box-shadow: 0 0px 5px 3px var(--Shadow1);
}
</style>
